class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);
// ---- Ramesto: hide tax/shipping note + terms checkbox in Quick Cart sidebar ----
function hideSidebarTaxAndTerms() {
  const sidebar = document.getElementById('halo-cart-sidebar');
  const previewCart = document.querySelector('.previewCart');
  const root = sidebar || previewCart;
  if (!root) return;

  // 1) Remove "Tax included and shipping calculated at checkout"
  root.querySelectorAll('.shipTotal, .tax-note, .cart__taxes, [data-shipping-note]').forEach((el) => {
    el.remove();
  });

  // 2) Remove Terms checkbox row completely (fixes leftover "I agree with")
  root.querySelectorAll(
    '.cart-checkbox, .global-checkbox, .terms-conditions, .terms, [data-term-condition], [data-terms-conditions]'
  ).forEach((el) => {
    el.remove();
  });

  // 3) Enable checkout button if it was disabled
  root.querySelectorAll('#cart-checkout, [data-cart-checkout], .button-checkout, button[name="checkout"]').forEach((btn) => {
    btn.removeAttribute('disabled');
    btn.classList.remove('disabled', 'button-disable');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  hideSidebarTaxAndTerms();

  const target = document.getElementById('halo-cart-sidebar') || document.querySelector('.previewCart');
  if (!target) return;

  const mo = new MutationObserver(hideSidebarTaxAndTerms);
  mo.observe(target, { childList: true, subtree: true });
});